// Module
var code = "<span class=\"mx-shell-nav-dropdown-wrapper\" mx-bind-html-compile=\"::vm.htmlTemplate\"></span>\r\n\r\n";
// Exports
export default code;